import { AxiosError } from "axios";
import React from "react";

const TourViewerErrorPage = ({ err }: { err: AxiosError }) => {
  return (
    <div style={{ color: "#888" }}>
      <h2>{err.message}</h2>
      <pre>{err.code}</pre>
      <p>{err.name}</p>
      {/* <textarea value={JSON.stringify(err, null, 4)} readOnly /> */}
      <br />
    </div>
  );
};

export default TourViewerErrorPage;
